import { render, staticRenderFns } from "./BubbleTest.vue?vue&type=template&id=559b0bda&"
import script from "./BubbleTest.vue?vue&type=script&lang=js&"
export * from "./BubbleTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports